module.exports = __webpack_public_path__ + "static/hero-d2b8ae3af5a6b327b073ceabecbdf17a.jpg";